// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"active-toast__wrap--2qzUh","show":"active-toast__show--oYKXm","text":"active-toast__text--270v7","btn":"active-toast__btn--3MXvm"};